import { render, staticRenderFns } from "./carbonfootprintCertificate.vue?vue&type=template&id=4263610f&scoped=true"
import script from "./carbonfootprintCertificate.vue?vue&type=script&lang=js"
export * from "./carbonfootprintCertificate.vue?vue&type=script&lang=js"
import style0 from "./carbonfootprintCertificate.vue?vue&type=style&index=0&id=4263610f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4263610f",
  null
  
)

export default component.exports